/**
 * Subscription + free gift. Maps: window.__subscriptionVariantFreeGiftMaps[sectionId] (from Liquid).
 * Resolves section from the form’s .shopify-section ancestor so keys always match the inline script.
 */
(function () {
  if (window.__buddySubscriptionFreeGiftLoaded) return;
  window.__buddySubscriptionFreeGiftLoaded = true;

  const MAPS_KEY = '__subscriptionVariantFreeGiftMaps';

  function getSectionIdFromForm(form) {
    const wrap = form?.closest?.('[id^="shopify-section-"]');
    if (wrap?.id) return wrap.id.replace(/^shopify-section-/, '') || null;
    const formId = form?.id || '';
    if (!formId.startsWith('product-form-')) return null;
    let rest = formId.slice('product-form-'.length);
    if (rest.endsWith('--alt')) rest = rest.slice(0, -6);
    return rest || null;
  }

  function getSectionEl(sectionId) {
    return document.getElementById(`shopify-section-${sectionId}`);
  }

  function getFreeVariantId(map, mainVariantId) {
    if (!map || typeof map !== 'object') return '';
    const k = String(mainVariantId).trim();
    let v = map[k];
    if (v == null || v === '') {
      const n = Number(k);
      if (!Number.isNaN(n)) v = map[n];
    }
    if (v == null || v === '') {
      for (const key of Object.keys(map)) {
        if (String(key) === k || String(Number(key)) === k) {
          v = map[key];
          break;
        }
      }
    }
    if (v == null || v === '') return '';
    return String(v).trim();
  }

  /** Shopify cart JSON success: HTTP ok and a cart object with items array. */
  function isCartAddSuccess(res, fetchOk) {
    return Boolean(
      fetchOk && res && typeof res === 'object' && Array.isArray(res.items),
    );
  }

  function getResolvedSellingPlan(section, form) {
    const fd = new FormData(form);
    let sp = fd.get('selling_plan');
    if (sp != null && String(sp).trim() !== '') return String(sp).trim();

    const inForm = form.querySelector('input.pi-selected-selling-plan-id[name="selling_plan"]');
    if (inForm?.value != null && String(inForm.value).trim() !== '') {
      return String(inForm.value).trim();
    }

    if (section) {
      const master = section.querySelector('.pi-selected-selling-plan-id[name="selling_plan"]');
      if (master?.value != null && String(master.value).trim() !== '') {
        return String(master.value).trim();
      }

      const visibleSection = section.querySelector('.pi-selling-plan-section:not(.pi-selling-plan-hidden)');
      const radio = visibleSection?.querySelector(
        'input.pi-selling-plan-option-input[data-radio-type="selling_plan"]:checked',
      );
      if (radio?.dataset?.sellingPlanId) {
        return String(radio.dataset.sellingPlanId).trim();
      }
    }

    return '';
  }

  function getResolvedVariantId(section, form) {
    const input = form.querySelector('input[name="id"], select[name="id"]');
    if (input?.value != null && String(input.value).trim() !== '') {
      return String(input.value).trim();
    }

    const fd = new FormData(form);
    const id = fd.get('id');
    if (id != null && String(id).trim() !== '') return String(id).trim();

    return '';
  }

  function shouldIntercept(section, form, map) {
    if (!map || typeof map !== 'object') return false;
    if (!getResolvedSellingPlan(section, form)) return false;
    const variantId = getResolvedVariantId(section, form);
    if (!variantId) return false;
    return Boolean(getFreeVariantId(map, variantId));
  }

  function buildPayload(items, cartDrawerEnabled, miniCart) {
    const payload = { items };
    if (cartDrawerEnabled && miniCart) {
      payload.sections = miniCart.getSectionsToRender().map((s) => s.id);
      payload.sections_url = window.location.pathname;
    }
    return JSON.stringify(payload);
  }

  async function onSubmitCapture(event) {
    const form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    const action = String(form.getAttribute('action') || '');
    if (!action.includes('/cart/add')) return;

    if (document.body.classList.contains('template-cart')) return;

    const sectionId = getSectionIdFromForm(form);
    if (!sectionId) return;

    const maps = window[MAPS_KEY];
    if (!maps || typeof maps !== 'object') return;

    const map = maps[sectionId];
    const section = getSectionEl(sectionId) || form.closest('[id^="shopify-section-"]');

    if (!shouldIntercept(section, form, map)) return;

    const mainVariantKey = getResolvedVariantId(section, form);
    const mainId = Number(mainVariantKey);
    if (!mainVariantKey || Number.isNaN(mainId)) return;

    const freeIdStr = getFreeVariantId(map, mainVariantKey);
    const freeId = Number(freeIdStr);
    if (!freeIdStr || Number.isNaN(freeId)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const productForm = form.closest('product-form');
    const submitButton =
      productForm?.querySelector('[type="submit"]') || form.querySelector('[type="submit"]');

    if (submitButton && !window.BuddyAddToCartLoading?.start(submitButton)) return;

    const miniCart = document.querySelector('mini-cart');
    const fd = new FormData(form);
    const qty = Math.max(1, parseInt(fd.get('quantity') || '1', 10) || 1);
    const sellingPlanStr = getResolvedSellingPlan(section, form);
    const sellingPlan = sellingPlanStr !== '' ? Number(sellingPlanStr) : null;

    const mainItem = { id: mainId, quantity: qty };
    if (sellingPlan != null && !Number.isNaN(sellingPlan)) {
      mainItem.selling_plan = sellingPlan;
    }

    for (const [key, value] of fd.entries()) {
      const m = key.match(/^properties\[(.+)\]$/);
      if (m) {
        mainItem.properties = mainItem.properties || {};
        mainItem.properties[m[1]] = value;
      }
    }

    const giftLine = {
      id: freeId,
      quantity: 1,
      properties: {
        _free_gift: 'Subscription promotion',
      },
    };

    const cartDrawerEnabled = Boolean(window.shopSettings?.cartDrawer);
    const body = buildPayload([mainItem, giftLine], cartDrawerEnabled, miniCart);

    const cartAddUrl = window.routes.cart_add_url.endsWith('.js')
      ? window.routes.cart_add_url
      : `${window.routes.cart_add_url}.js`;

    function finishSuccess(response) {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'subscription-variant-free-gift',
          productVariantId: String(mainId),
        });
      }
      if (cartDrawerEnabled && miniCart) {
        miniCart.handleCartAddSuccess(response, submitButton);
      } else if (window.routes?.cart_url) {
        window.location.assign(window.routes.cart_url);
      } else {
        window.location.assign('/cart');
      }
    }

    function showError(desc, response) {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'subscription-variant-free-gift',
          productVariantId: String(mainId),
          errors: response?.errors || response?.description,
          message: response?.message,
        });
      }
      if (productForm && typeof productForm.handleErrorMessage === 'function') {
        productForm.handleErrorMessage(desc || response?.description);
      } else if (desc || response?.description) {
        alert(desc || response.description);
      }
    }

    try {
      let fetchResponse = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body,
      });

      let response = await fetchResponse.json();

      if (isCartAddSuccess(response, fetchResponse.ok)) {
        finishSuccess(response);
        return;
      }

      const mainOnly = buildPayload([mainItem], cartDrawerEnabled, miniCart);
      fetchResponse = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: mainOnly,
      });
      let first = await fetchResponse.json();

      if (!isCartAddSuccess(first, fetchResponse.ok)) {
        showError(first?.description, first);
        return;
      }

      const giftOnly = buildPayload([giftLine], cartDrawerEnabled, miniCart);
      fetchResponse = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: giftOnly,
      });
      const second = await fetchResponse.json();

      if (!isCartAddSuccess(second, fetchResponse.ok)) {
        showError(second?.description, second);
        return;
      }

      finishSuccess(second);
    } catch (e) {
      showError(window.cartStrings?.error || 'Unable to add this item to your cart. Please try again.');
      if (window.BuddyCartDrawerDebug === true) console.debug('subscription-variant-free-gift', e);
    } finally {
      if (submitButton) {
        window.BuddyAddToCartLoading?.stop(submitButton);
      }
    }
  }

  document.addEventListener('submit', onSubmitCapture, true);
})();
